export default {
    setHomeMatches: (state, homeMatches) => (state.homeMatches = homeMatches),
    setHomeVisitors: (state, homeVisitors) => (state.homeVisitors = homeVisitors),
    setHomeMeetings: (state, homeMeetings) => (state.homeMeetings = homeMeetings),
    setHomeMessages: (state, homeMessages) => (state.homeMessages = homeMessages),
    setHomeOnline: (state, homeOnline) => (state.homeOnline = homeOnline),
};